import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import AlertBox from 'components/ui/AlertBox';
import { legShape } from 'constants/propTypes';

import { StyledAlertBox } from '../Leg.styles';

import useDelayDurationQuery from 'components/queries/useDelayDurationQuery';
import { delayDifferenceThreshold } from './utils.js';

const StarlightDelayAlertBox = ({ bookingReference, journey }) => {
  const { activeBookingItems = [] } = journey;

  const ticketNumbers = activeBookingItems.map((item) => item?.ticketNumber);

  const { delayDurationMins, loading } = useDelayDurationQuery({ ticketNumbers, bookingReference });

  if (loading) {
    return null;
  }

  const message = 'journeySegment.starlightDelayAlert';
  const above60MinsDelay = delayDurationMins > delayDifferenceThreshold;

  if (!above60MinsDelay) {
    return null;
  }

  return (
    <StyledAlertBox variant={AlertBox.variants.INFO}>
      <FormattedMessage id={message} values={{ delayDurationMins }} />
    </StyledAlertBox>
  );
};

StarlightDelayAlertBox.propTypes = {
  journey: legShape.isRequired,
  bookingReference: PropTypes.string
};

export default injectIntl(StarlightDelayAlertBox);
